import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  className?: string;
}
export function SectionHeading({
  title,
  subtitle,
  centered = true,
  className = ''
}: SectionHeadingProps) {
  return <div className={`mb-8 ${centered ? 'text-center' : 'text-left'} ${className}`} data-id="element-365">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="gold-shine font-script font-semibold text-4xl md:text-5xl lg:text-6xl mb-4 tracking-tight" dangerouslySetInnerHTML={{
      __html: title
    }} data-id="element-366" />
      {subtitle && <motion.p initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="font-sans text-riam-gold-light/80 text-lg max-w-2xl mx-auto" data-id="element-367">
          {subtitle}
        </motion.p>}
      <motion.div initial={{
      scaleX: 0
    }} whileInView={{
      scaleX: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      delay: 0.4
    }} className={`gold-divider mt-6 ${centered ? 'mx-auto w-32' : 'w-32'}`} data-id="element-368" />
    </div>;
}